export interface RecordListPositionOptions {
  /** Index within the rendered page, or null when nothing is hovered. */
  index: number | null;
  renderedCount: number;
  page: number;
  pageSize: number;
  /** Records matching the current filters across every page. */
  total: number;
}

/**
 * Position of a hovered row within the whole filtered set, not just the page
 * it happens to be rendered on, so paging does not restart the count.
 * Returns an empty string when there is nothing meaningful to show.
 */
export function formatRecordListPosition({ index, renderedCount, page, pageSize, total }: RecordListPositionOptions): string {
  if (index === null || index < 0 || index >= renderedCount) return "";
  if (total <= 0 || page < 1 || pageSize < 1) return "";

  const position = (page - 1) * pageSize + index + 1;
  if (position > total) return "";

  return `(${position.toLocaleString()}/${total.toLocaleString()})`;
}
